'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _category_listing = require('./components/category_listing');

var _category_listing2 = _interopRequireDefault(_category_listing);

var _category_add = require('./components/category_add');

var _category_add2 = _interopRequireDefault(_category_add);

var _category_edit = require('./components/category_edit');

var _category_edit2 = _interopRequireDefault(_category_edit);

var _list = require('./components/list');

var _list2 = _interopRequireDefault(_list);

var _add = require('./components/add');

var _add2 = _interopRequireDefault(_add);

var _edit = require('./components/edit');

var _edit2 = _interopRequireDefault(_edit);

var _images = require('./components/images.config');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _images2 = require('./services/images.service');

var _images3 = _interopRequireDefault(_images2);

var _imagesDataprovider = require('./services/images.dataprovider.service');

var _imagesDataprovider2 = _interopRequireDefault(_imagesDataprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('images', [_angularUiRouter2.default, _ngFileUpload2.default]).component('imageCategoryList', _category_listing2.default).component('imageCategoryAdd', _category_add2.default).component('imageCategoryEdit', _category_edit2.default).component('imageList', _list2.default).component('imageAdd', _add2.default).component('imageEdit', _edit2.default).service('Images', _images3.default).service('ImagesDataProvider', _imagesDataprovider2.default).config(_images.ImagesConfig).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/index.js
 **/